import { keyframes } from '@emotion/core';
import { Colors } from '@zapier/design-system/dist/theme';
import { isolateComponent, labelStyles } from '@zapier/common-utils';
const dotCount = 3;
const animationDuration = 500;
const dotPulse = keyframes `
  0% { transform: scale(1); }
  100% { transform: scale(0.7); }
`;
const Styles = labelStyles(__filename, {
    root: {
        overflow: 'visible',
    },
    dot: {
        animation: `${dotPulse} ${animationDuration}ms ease-in-out alternate
        infinite`,
    },
});
export const AsyncIndicator = ({ ariaLabel = 'Loading', color = 'grey500', dotSize = 6, }) => {
    const r = dotSize / 2;
    const height = dotSize;
    const width = dotCount * dotSize * 1.5 - r;
    const dots = Array.from({
        length: dotCount,
    }).map((_n, i) => {
        const cx = (i * 3 + 1) * r;
        const cy = r;
        const style = {
            animationDelay: `${i * (animationDuration / dotCount)}ms`,
            transformOrigin: `${cx}px ${cy}px`,
        };
        return (isolateComponent("circle", { css: Styles.dot, cx: cx, cy: cy, fill: color === 'inherit' ? 'currentColor' : Colors[color] || color, key: i, r: r, style: style }));
    });
    return (isolateComponent("svg", { "aria-hidden": "false", "aria-label": ariaLabel, css: Styles.root, height: height, width: width }, dots));
};
//# sourceMappingURL=AsyncIndicator.js.map
